import React from 'react'
import { userTypes } from '../../constants/constants'
import OrientationOverlay from './OrientationOverlay'
import rotateIcon from './Icons/rotate-device.png'
import widenIcon from './Icons/widen-window.png'

export default function Orientation({orientation, userRole}){

    if(userRole !== userTypes.STUDENT) return null

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.maxTouchPoints > 1

    const lessThan4by3AspectRatio = (window.innerHeight / window.innerWidth) > 0.75

    if(orientation === 'portrait' || lessThan4by3AspectRatio){
        if(isMobile){
            return <OrientationOverlay text="Please rotate your device to landscape to continue." icon={rotateIcon}/>
        }else{
            return <OrientationOverlay text="Please widen your window to continue." icon={widenIcon}/>
        }
    }

    return null
}